import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { infoCardActions } from './info-card.actions';
import { delay, exhaustMap, map } from 'rxjs';
import { LoadingState } from '../models/loader.model';
import { mapResponse } from '@ngrx/operators';
import { InfoCardItem } from './info-card.reducer';

// effetto mock stats 1
export const infoCardLoad1Effect = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(infoCardActions.load1),
      // per ogni load, emetti dati finti
      map((props) => {
        // dati mock
        const mockData: InfoCardItem = {
          value: 123,
          icon: 'earn',
          infoDescription: 'Incassi totali',
        };

        //dispatch della action done
        return infoCardActions.done1({
          data: mockData,
          state: { value: LoadingState.SUCCESS },
        });
      }),
      // ritardo simulato
      delay(500),
    );
  },
  { functional: true },
);

export const infoCardLoad2Effect = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(infoCardActions.load2),
      // per ogni load, emetti dati finti
      map((props) => {
        // dati mock
        const mockData: InfoCardItem = {
          value: 5546,
          icon: 'pi pi-clock',
          infoDescription: 'Testo abbastanza così',
        };

        //dispatch della action done
        return infoCardActions.done2({
          data: mockData,
          state: { value: LoadingState.SUCCESS },
        });
      }),
      // ritardo simulato
      delay(500),
    );
  },
  { functional: true },
);

export const infoCardLoad3Effect = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(infoCardActions.load3),
      // per ogni load, emetti dati finti
      map((props) => {
        // dati mock
        const mockData: InfoCardItem = {
          value: 6656,
          icon: 'pi pi-clock',
        };

        //dispatch della action done
        return infoCardActions.done3({
          data: mockData,
          state: { value: LoadingState.SUCCESS },
        });
      }),
      // ritardo simulato
      delay(500),
    );
  },
  { functional: true },
);
export const infoCardLoad4Effect = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(infoCardActions.load4),
      // per ogni load, emetti dati finti
      map((props) => {
        // dati mock
        const mockData: InfoCardItem = {
          value: 7,
          infoDescription: 'Non ho icona',
        };

        //dispatch della action done
        return infoCardActions.done4({
          data: mockData,
          state: { value: LoadingState.SUCCESS },
        });
      }),
      // ritardo simulato
      delay(500),
    );
  },
  { functional: true },
);
